import { Component, OnInit } from '@angular/core';

import { FormControl, FormGroupDirective, NgForm, Validators, FormGroup, NgModel, AbstractControl, FormBuilder } from '@angular/forms';
import { ErrorStateMatcher} from '@angular/material/core';
import { LanguageService } from 'src/app/services/language/language.service'

// Constants
import { GlobalConstant } from 'src/app/constants/global-constant';


/* Error when invalid control is dirty, touched, or submitted (input fields) */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    //const isSubmitted = form && form.submitted;
    //return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    return !!(control && control.invalid && (control.dirty || control.touched ));
  }
}



@Component({
  selector: 'app-time-field',
  templateUrl: './time-field.component.html',
  styleUrls: ['./time-field.component.css']
})
export class TimeFieldComponent implements OnInit {

    public inputParameters: any = {};
    public inputData: any = {};

    fieldDisabled: boolean;
  
    // Individual form controls and error matcher
    formControlGroup:any;
    hoursControl = new FormControl(null, [Validators.min(0)]);
    minutesControl = new FormControl(null, [Validators.min(0), Validators.max(59)]);
    secondsControl = new FormControl(null, [Validators.min(0), Validators.max(59)]);
    matcher = new MyErrorStateMatcher();


    constructor(public languageService: LanguageService) {}
  
    ngOnInit(): void {
      // Create the form control group
      this.formControlGroup = new FormGroup({
        hours: this.hoursControl,
        minutes: this.minutesControl,
        seconds: this.secondsControl
      })
      // Add the validators
      //    Required validator
      if(this.inputParameters.required){
        this.hoursControl.addValidators(Validators.required)
        this.minutesControl.addValidators(Validators.required)
        this.secondsControl.addValidators(Validators.required)
      }
      //    Integer validator
      this.hoursControl.addValidators(this.integerValidator.bind(this))
      this.minutesControl.addValidators(this.integerValidator.bind(this))
      this.secondsControl.addValidators(this.integerValidator.bind(this))
      
      // Set the current value   
      if(this.inputData){
        if(this.inputData.value){
          this.initializationProcesses(this.inputData.value)
        }
      }
    }


    initializationProcesses(durationInSeconds){
      if(durationInSeconds != null){
        const hours = Math.floor(durationInSeconds / 3600)
        const remainingSecondsAfterHours = durationInSeconds % 3600
        const minutes = Math.floor(remainingSecondsAfterHours / 60)
        const seconds = remainingSecondsAfterHours % 60
        // Set values
        this.hoursControl.setValue(hours)
        this.minutesControl.setValue(minutes)
        this.secondsControl.setValue(seconds)
      }else{
        // Set values
        this.hoursControl.setValue(null)
        this.minutesControl.setValue(null)
        this.secondsControl.setValue(null)
      }
    }




    getValueC(): any {
      let durationInSeconds = null
      if(this.hoursControl.value !== null || this.minutesControl.value !== null || this.secondsControl.value !== null){
        const h = this.hoursControl.value;
        const m = this.minutesControl.value;
        const s = this.secondsControl.value;
        durationInSeconds = h * 3600 + m * 60 + s;
      }
      // Reset the view
      this.initializationProcesses(durationInSeconds)
      // Return the updated information
      return durationInSeconds
    }


    setValueC(input: any) {
      if (input) {
        this.initializationProcesses(input)
      }
    }





  
    getResultDict() {
      let durationInSeconds = null
      /*
      if(this.hoursControl.value !== null && this.minutesControl.value !== null && this.secondsControl.value !== null &&
        this.hoursControl.value !== undefined && this.minutesControl.value !== undefined && this.secondsControl.value !== undefined
      ){
      */
      if(this.hoursControl.value !== null || this.minutesControl.value !== null || this.secondsControl.value !== null){
        const h = this.hoursControl.value;
        const m = this.minutesControl.value;
        const s = this.secondsControl.value;
        durationInSeconds = h * 3600 + m * 60 + s;
      }
      return {
        key: this.inputParameters.key,
        type: this.inputParameters.type,
        value: durationInSeconds  
      };
    }







    // ----- Custom validators ------ //
    // Custom step validation functions
    integerValidator(control: AbstractControl) {
      const value = control.value;
      // Verify that there is a numeric value
      if (value === null || value === undefined || value === '') {
        return null;
      }
      // Validate
      const numValue = Number(value);
      if (isNaN(numValue) || numValue % 1 !== 0) {
        //return { notInteger: { value: control.value } };
        return { integerValidationError: true }
      }
      // Return null if valid
      return null;
    }


}
